// Subscribe & Save — delegated click handling for the per-line-item trigger.
//
// Loaded unconditionally from cart-drawer.liquid (a static, always-rendered
// part of the page shell), not from inside subscribe-and-save.liquid itself.
//
// Reason: subscribe-and-save.liquid only renders once an eligible item is in
// the cart. On a first-time visitor's first add-to-cart, Dawn injects that
// markup via innerHTML during an AJAX cart update — and browsers never
// execute <script> tags that arrive through innerHTML. A script living
// inside the conditional snippet would silently never bind until the next
// full page load (i.e. a refresh). Loading it here instead means the click
// listener is attached during the real, parsed page load, before any item
// is ever added — so it's already active by the time a trigger appears.
(function () {
  if (window.__glissantSubscribeSaveBound) return;
  window.__glissantSubscribeSaveBound = true;

  function closeAll(except) {
    document.querySelectorAll('[data-subscribe-save]').forEach(function (wrapper) {
      if (wrapper === except) return;
      var popover = wrapper.querySelector('.subscribe-save__popover');
      var trigger = wrapper.querySelector('[data-ss-trigger]');
      if (popover) popover.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var cta = target.closest('[data-subscribe-save-cta]');
    if (cta) {
      var payload = {
        product_handle: cta.getAttribute('data-ss-product') || '',
        destination: cta.href,
      };
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'subscribe_save_click', payload);
      }
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', 'SubscribeSaveClick', payload);
      }
      return;
    }

    if (target.closest('[data-ss-close]')) {
      closeAll();
      return;
    }

    var trigger = target.closest('[data-ss-trigger]');
    if (!trigger) {
      closeAll();
      return;
    }

    var wrapper = trigger.closest('[data-subscribe-save]');
    var popover = wrapper.querySelector('.subscribe-save__popover');
    var wasOpen = !popover.hidden;

    closeAll(wrapper);
    popover.hidden = wasOpen;
    trigger.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');

    if (!wasOpen) {
      // Just opened. The card expands in flow below the trigger, and on
      // desktop especially there's often enough chrome above the cart
      // items (promo bar, free-shipping progress) that the newly-opened
      // card lands below the visible drawer area even when the trigger
      // itself was in view. Bring it into view without jumping the whole
      // page — 'nearest' only scrolls if it's not already visible, and
      // scrollIntoView respects the drawer's own internal scroll
      // container rather than the window.
      requestAnimationFrame(function () {
        popover.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });
})();
